import {
  createNewestFirstPollingPaginationPolicy,
  createPaginationPolicy,
  createUpdateQueryPaginationPolicy,
} from '@repo/frontend-shared/graphql';

export const fetchMoreConfig = {
  // Separate cache entries by filter criteria to prevent cache collisions
  // This ensures queries with different filters get their own cache entries

  // Merged by useInfiniteList's updateQuery; retain `first` in cache identity.
  discountDeals: createUpdateQueryPaginationPolicy(),

  // Same merge path. Keys keep every argument except cursors, so rank-ordered (default) and date-ordered
  // (`orderBy`/`orderDirection`) pages, filters and the Manage order view never share a cache entry.
  adminDiscountDeals: createUpdateQueryPaginationPolicy(),

  documentTemplates: createPaginationPolicy(),

  emailTemplates: createPaginationPolicy(),

  scenarios: createPaginationPolicy(),

  adminScenarios: createPaginationPolicy(),

  featureFlags: createPaginationPolicy(),

  partners: createPaginationPolicy(),

  // Merged by useInfiniteList's fetchMore.updateQuery — the policy must not
  // append a second time.
  adminPartnerMembers: createUpdateQueryPaginationPolicy(),

  users: createPaginationPolicy(),

  assignableUsersForScope: createPaginationPolicy(),

  assignableCohortsForScope: createPaginationPolicy(),

  courses: createPaginationPolicy(),

  liveEvents: createPaginationPolicy(),

  posts: createPaginationPolicy(),

  // The two live moderation queues (useLiveModerationQueue):
  // cursorless poll/refetch replaces; fetchMore appends. Poll with first >= loaded count.
  adminPosts: createNewestFirstPollingPaginationPolicy(),

  pendingReports: createNewestFirstPollingPaginationPolicy(),

  videos: createPaginationPolicy(),

  goodieBagDiscountDeals: createPaginationPolicy(),
};
